import { seoContent } from '@/mocks/content';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20flat%20lay%20photography%20of%20curated%20fashion%20items%20and%20accessories%20arranged%20in%20an%20artistic%20grid%20on%20cream%20marble%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20catalog%20aesthetic%2C%20warm%20neutral%20tones%2C%20minimal%20luxury%20composition%2C%20organized%20spreadsheet%20concept%20with%20product%20photos%20scattered%20artistically&width=1600&height=900&seq=hero-main-v2-2026&orientation=landscape"
          alt="CSSBuySpreadsheet produtos organizados por categoria"
          title="CSSBuySpreadsheet 2026 – A Planilha Mais Completa"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/35"></div>

      <div className="relative w-full px-6 md:px-10 lg:px-16 pt-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white/90 text-xs md:text-sm font-medium mb-6 md:mb-8 whitespace-nowrap">
            {seoContent.heroTag}
          </span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-5 md:mb-6">
            {seoContent.heroTitle}
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-xl leading-relaxed mb-8 md:mb-10">
            {seoContent.heroSubtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm md:text-base hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Ver Planilha CSSBuy Completa
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-white/50 text-white font-medium text-sm md:text-base hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
            >
              Acessar Site Principal
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}